import { createHOC } from 'vue-hoc';
import omit from 'lodash/omit';

import auth, { authResultKey } from '../providers/auth';

export default function withUser() {
  return (Component) => {
    const options = {
      name: Component.name + '-with-user',

      created() {
        const user = this.user();
        if (user) {
          const orgCount = (user.groupsData || []).filter(group => !group.metadata.parent).length;
          // window.gtag('set', 'role', user.role);
          this.$gtag.set('user_properties', {
            user_id: user.id,
            role: user.role,
            org: user.groupsData ? user.groupsData[0].name : null,
            org_id: user.groupsData ? user.groupsData[0]._id : null,
            org_count: orgCount,
          });
        }
        auth.on('sessionRenewed', () => {
          this.$forceUpdate();
        });
      },
      methods: {
        user() {
          return auth.getUser();
        }
      },
    };

    const renderWith = {
      props: {
        user() {
          return this.user();
        },
        idToken() {
          const authResult = JSON.parse(localStorage.getItem(authResultKey));
          return authResult && authResult.idToken;
        },
      },
      listeners: {
        async logout() {
          await auth.logout();
        },
      },
    };

    const AugmentedComponent = createHOC(Component, options, renderWith);
    AugmentedComponent.props = omit(AugmentedComponent.props, 'user', 'idToken');
    return AugmentedComponent;
  };
}
